module.exports = __webpack_public_path__ + "static/media/hero.10c0173e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/agenda/hero.jpg
// module id = 932
// module chunks = 0